import { hasNewsManagerAccess } from "@slfinrtl/ppn-roles"
import { useMemo } from "react"
import { getFeatureToggle } from "src/common/getConfig"
import { getJwtPayload } from "src/common/jwt/jwtUtils"

/** access to creating and deleting entries */
export const useHasNewsManagerAccess = (): boolean =>
	useMemo(() => {
		const jwtClaims = getJwtPayload()
		return getFeatureToggle("news-enabled") && !!jwtClaims && hasNewsManagerAccess(jwtClaims["ppn:groups"])
	}, [])
